import { trans } from "@mongez/localization";

export function BasicInformation() {
  return (
    <div className="bg-[#f7f9fc] py-10 lg:py-20">
      <div className="container">
        <div className="flex flex-col gap-8 rounded-3xl bg-white p-8 shadow-md">
          <h3 className="text-lg font-semibold text-bright-orange sm:text-xl lg:text-2xl">
            {trans("basicInfo.title")}
          </h3>
          <div className="grid w-full grid-cols-1 gap-2 text-sm font-light sm:text-lg md:grid-cols-2 md:gap-5 lg:text-xl">
            <span>{trans("city")}</span>
            <span className="font-medium">
              {trans("basicInfo.data.dammam")}
            </span>

            <span>{trans("estDate")}</span>
            <span className="font-medium">
              {trans("basicInfo.data.8 July 1998")}
            </span>

            <span>{trans("listingDate")}</span>
            <span className="font-medium">
              {trans("basicInfo.data.9 February 2002")}
            </span>

            <span>{trans("website")}</span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://senaat.com/en/"
              className="font-medium hover:text-marine hover:underline"
            >
              {trans("senaat.com")}
            </a>

            <span>{trans("phone")}</span>
            <a
              href="tel:+966 13 810 8111"
              dir="ltr"
              className="font-medium hover:text-marine hover:underline ltr:text-left rtl:text-right"
            >
              {trans("+966 13 810 8111")}
            </a>

            <span>{trans("address")}</span>
            <span className="font-medium">
              {trans(
                "basicInfo.data.P. O. Box 14441, Dammam 31424, Saudi Arabia",
              )}
            </span>

            <span>{trans("ownershipType")}</span>
            <span className="font-medium">
              {trans("basicInfo.data.Joint Stock")}
            </span>

            <span>{trans("fiscalYear")}</span>
            <span className="font-medium">
              {trans("basicInfo.data.Jan. 01 - Dec. 31")}
            </span>

            <span>{trans("numOfEmployees")}</span>
            <span className="font-medium">{trans("9,000")}</span>

            <span>{trans("email")}</span>
            <a
              href="mailto:investors@senaat.com"
              className="font-medium hover:text-marine hover:underline"
            >
              {trans("investors@senaat.com")}
            </a>

            <span>{trans("fax")}</span>
            <a
              href="tel:+966 13 810 8199"
              dir="ltr"
              className="font-medium hover:text-marine hover:underline ltr:text-left rtl:text-right"
            >
              {trans("+966 13 810 8199")}
            </a>

            <span>{trans("externalAuditors")}</span>
            <span className="font-medium">
              {trans("basicInfo.data.KPMG (Public Accountants)")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
